export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZGV2bmFubyIsImEiOiJja3I2ZXI2NWIzZXg2MnBtdDNjZXNhd2JnIn0.pKD3qaMPhllUm115EjNf-Q';
export const MAPBOX_DEFAULT_STYLE = 'mapbox://styles/mapbox/satellite-streets-v9';
export const MAP_DEFAULT_CENTER = [-64.273833, -31.006031]

export const API_DOMAIN = 'localhost';
export const MODIS_24_URL = 'http://127.0.0.1:8000/api/v1/firms/modis/';
export const VIIRS_24_URL = 'http://127.0.0.1:8000/api/v1/firms/viirs/';
export const GOES_URL = 'http://127.0.0.1:8000/api/v1/firms/goes/';
export const API_BASE_URL = `https://api.hmap.commite.ar/api`;
